import { Result } from '../../result/result.bean'

export class User extends Result
{
    token : string
    level : number
    forced: number

    public static isKind ( user: any )
    {
        return  user                != undefined &&
                user.token          != undefined &&
                user.level          != undefined &&
                user.forced         != undefined &&
                Result.isKind(user) != undefined
    }
}